import { UserRoles } from '@/enums';
import { ProductSharedPages } from '@/modules/products/shared/types';
import { all_internal_roles } from '@/utils';

const access_roles = {
  [ProductSharedPages.CATALOG]: all_internal_roles,
  [ProductSharedPages.PRODUCT_DETAIL]: all_internal_roles,
};

export default access_roles;
